module.exports = __webpack_public_path__ + "static/img/霾.4bac5086.svg";